// Edit this file to add, remove, reorder, or update faculty members for this department.
const facultyData = {
  "hod": {
    "id": "f-nagaraj-bhat",
    "name": "Dr. Nagaraj Bhat",
    "designation": "Associate Professor & HOD",
    "role": "Associate Professor & HOD",
    "qualification": "M.Tech., Ph.D.",
    "qualifications": "M.Tech., Ph.D.",
    "image": "/FacultyCImages/DR_nagaraj_bhat_ECE.jpeg",
    "email": "ndb@klsvdit.edu.in",
    "phone": "+91 73536 99907",
    "showPhone": true,
    "experience": "14 years",
    "description": "Dr. Nagaraj Bhat is an Associate Professor & Head of the Department of Electronics and Communication Engineering. He earned his Ph.D. from VTU in 2020 and holds an M.Tech in Digital Electronics from SDMCET, Dharwad. His research interests include Image Processing, Signal Processing, and related emerging technologies.",
    "bio": "Dr. Nagaraj Bhat is an Associate Professor & Head of the Department of Electronics and Communication Engineering. He earned his Ph.D. from VTU in 2020 and holds an M.Tech in Digital Electronics from SDMCET, Dharwad. His research interests include Image Processing, Signal Processing, and related emerging technologies.",
    "specializations": [
      "Image Processing",
      "Signal Processing",
      "Very Large Scale Integration (VLSI)"
    ],
    "areas": [
      "Image Processing",
      "Signal Processing",
      "Very Large Scale Integration (VLSI)"
    ],
    "courses": [
      "Electromagnetic Theory",
      "Control Systems",
      "Verilog Hardware Description Language (HDL)",
      "Digital Electronics"
    ],
    "publications": 8,
    "projects": 0,
    "linkedin": "https://www.linkedin.com/in/nagaraj-bhat-7896b7188",
    "irins": "",
    "recognition": [
      "information to be updated"
    ]
  },
  "members": [
    {
      "id": "f-rajeshwari-pashupatimath",
      "name": "Mrs. Rajeshwari Pashupatimath",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/rajeshwari_pashupatimath_ECE.jpeg",
      "email": "rap@klsvdit.edu.in",
      "phone": "+91 63626 85217",
      "showPhone": false,
      "experience": "2years 5 months",
      "description": "Mrs. Rajeshwari Pashupatimath serves as an Assistant Professor in the Department of Electronics and Communication Engineering (E&CE) at KLS VDIT, Haliyal. Her academic and research interests are centered on Image Processing, with a focus on exploring innovative techniques and applications in the field. She is currently pursuing her Ph.D. as a Research Scholar at KLS VDIT, Haliyal, contributing to research in advanced image processing technologies. She is actively involved in teaching, mentoring students, and engaging in research activities that bridge theoretical concepts with practical applications in Electronics and Communication Engineering.",
      "bio": "Mrs. Rajeshwari Pashupatimath serves as an Assistant Professor in the Department of Electronics and Communication Engineering (E&CE) at KLS VDIT, Haliyal. Her academic and research interests are centered on Image Processing, with a focus on exploring innovative techniques and applications in the field. She is currently pursuing her Ph.D. as a Research Scholar at KLS VDIT, Haliyal, contributing to research in advanced image processing technologies. She is actively involved in teaching, mentoring students, and engaging in research activities that bridge theoretical concepts with practical applications in Electronics and Communication Engineering.",
      "specializations": [
        "Image Processing"
      ],
      "areas": [
        "Image Processing"
      ],
      "courses": [
        "Microcontroller",
        "Digital Communication"
      ],
      "publications": 2,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/rajeshwari-pashupatimath-83890b413?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "irins": "https://klsvdit.irins.org//profile/710415",
      "recognition": [
        "Authored and co-authored research papers in reputed national and international journals and conferences",
        "Serving as the Institutional Coordinator for Indian Science, Technology and Engineering facilities Map (I-STEM), facilitating research infrastructure sharing and collaboration",
        "Working as the Karnataka Science and Technology Academy (KSTA) Coordinator, promoting scientific awareness, innovation, and technology-driven activities among students and faculty",
        "Ambassador of Institution Innovation Council (IIC)",
        "Coordinator of Indian Science Technology and Engineering facilities Map (I-STEM)",
        "Research Scholar",
        "Coordinator of Karnataka Science and Technology Academy (KSTA)"
      ]
    },
    {
      "id": "f-raghavendra-nagaralli",
      "name": "Mr. Raghavendra Nagaralli",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/raghavendra_nagaralli_ECE.jpeg",
      "email": "rpn@klsvdit.edu.in",
      "phone": "+91 97420 76542",
      "showPhone": false,
      "experience": "13 years",
      "description": "Mr. Raghavendra Nagaralli is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. His research focuses on the application of Deep Learning algorithms in Image Processing. His areas of interest include Artificial Intelligence, Machine Learning, and Deep Learning, contributing to innovative research and technological advancements.",
      "bio": "Mr. Raghavendra Nagaralli is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. His research focuses on the application of Deep Learning algorithms in Image Processing. His areas of interest include Artificial Intelligence, Machine Learning, and Deep Learning, contributing to innovative research and technological advancements.",
      "specializations": [
        "Deep learning",
        "Image Processing",
        "Machine Learning"
      ],
      "areas": [
        "Deep learning",
        "Image Processing",
        "Machine Learning"
      ],
      "courses": [
        "Computer Communication Networking",
        "Network Security",
        "Operating System",
        "Computer Organization"
      ],
      "publications": 5,
      "projects": 2,
      "linkedin": "https://www.linkedin.com/in/raghavendra-nagaralli9/",
      "irins": "https://klsvdit.irins.org/profile/249315",
      "recognition": [
        "Successfully completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) CERTIFICATION PROGRAMME in CYBER PHYSICAL SYSTEM from Indian Institute of Information Technology (IIIT) DHARWAD during June - Dec 2025"
      ]
    },
    {
      "id": "f-pavitra-m-badiger",
      "name": "Ms. Pavitra M Badiger",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/pavitra_badiger_ECE.jpeg",
      "email": "pmb@klsvdit.edu.in",
      "phone": "+91 89040 17520",
      "showPhone": false,
      "experience": "2.5 years",
      "description": "Ms. Pavitra M. Badiger is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT since 2023. She is currently pursuing Ph.D. research in Image Processing under VTU. Her research work has been presented at an international conference, reflecting her commitment to academic excellence and research advancement.",
      "bio": "Ms. Pavitra M. Badiger is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT since 2023. She is currently pursuing Ph.D. research in Image Processing under VTU. Her research work has been presented at an international conference, reflecting her commitment to academic excellence and research advancement.",
      "specializations": [
        "Image processing"
      ],
      "areas": [
        "Image processing"
      ],
      "courses": [
        "Computer Networks And Protocols",
        "Destination-Sequenced Distance Vector (DSDV)"
      ],
      "publications": 6,
      "projects": 1,
      "linkedin": "https://www.linkedin.com/in/pavitra-badiger-664b78377?trk=contact-info",
      "irins": "https://klsvdit.irins.org/profile/441310#personal_information_panel",
      "recognition": [
        "Working as Assistant Professor in Electronics and Communication Engineering (E&CE) department",
        "Department Internal Assessment (IA) coordinator",
        "Departments mentoring / Counseling coordinator",
        "Institution Innovation Council (IIC) ambassador",
        "Research scholar of the college"
      ]
    },
    {
      "id": "f-sudheendra-yalagur",
      "name": "Mr. Sudheendra Yalagur",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/sudhindra_yalagur_ECE.jpeg",
      "email": "shy@klsvdit.edu.in",
      "phone": "+91 97383 47968",
      "showPhone": false,
      "experience": "15 years",
      "description": "Mr. Sudheendra Yalagur is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. His academic interests include Embedded Systems, Signal Processing, Computer Networks, and Wireless Communication. He is passionate about teaching, research, and mentoring students, fostering innovation, critical thinking, and practical problem-solving skills.",
      "bio": "Mr. Sudheendra Yalagur is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. His academic interests include Embedded Systems, Signal Processing, Computer Networks, and Wireless Communication. He is passionate about teaching, research, and mentoring students, fostering innovation, critical thinking, and practical problem-solving skills.",
      "specializations": [
        "Embedded Systems",
        "Signal Processing",
        "Computer Networks",
        "Wireless Communication"
      ],
      "areas": [
        "Embedded Systems",
        "Signal Processing",
        "Computer Networks",
        "Wireless Communication"
      ],
      "courses": [
        "Network Analysis",
        "Digital Signal Processing",
        "Embedded Systems",
        "Control Systems"
      ],
      "publications": 3,
      "projects": 0,
      "linkedin": "http://www.linkedin.com/in/sudheendra-yalagur-39645818",
      "irins": "https://klsvdit.irins.org/profile/715460",
      "recognition": [
        "PROJECT BATCHES RECEIVED Karnataka State Council for Science and Technology (KSCST) PROJECT GRANTS UNDER MY GUIDENCE"
      ]
    },
    {
      "id": "f-ashwini-garaddi",
      "name": "Mrs. Ashwini Garaddi",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/ashwini_garaddi_ECE.jpeg",
      "email": "asg@klsvdit.edu.in",
      "phone": "+91 88846 41965",
      "showPhone": false,
      "experience": "2 years",
      "description": "Mrs. Ashwini Garaddi completed M. Tech. from KLS VDIT and is pursuing Ph.D. from AMC Engineering College, Bengaluru under VTU. Her research areas are Antenna design, communication subsystem design.",
      "bio": "Mrs. Ashwini Garaddi completed M. Tech. from KLS VDIT and is pursuing Ph.D. from AMC Engineering College, Bengaluru under VTU. Her research areas are Antenna design, communication subsystem design.",
      "specializations": [
        "Antenna Design",
        "Communication subsystem design"
      ],
      "areas": [
        "Antenna Design",
        "Communication subsystem design"
      ],
      "courses": [
        "Network Security",
        "Wireless Communication System",
        "Microcontroller",
        "Hybrid Electric Vehicles"
      ],
      "publications": 3,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/ashwini-garaddi-b50973339?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "irins": "https://vidwan.inflibnet.ac.in/profile/563950",
      "recognition": [
        "Completed National Programme on Technology Enhanced Learning (NPTEL) Courses, published patent on antenna",
        "Project coordinator",
        "Enterprise Resource Planning (ERP) coordinator",
        "Institution Innovation Council (IIC) Innovation Ambassador"
      ]
    },
    {
      "id": "f-jyoti-kammar",
      "name": "Mrs. Jyoti Kammar",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/jyothi_kammar_ECE.jpeg",
      "email": "jsk@klsvdit.edu.in",
      "phone": "+91 98456 23368",
      "showPhone": false,
      "experience": "1 years",
      "description": "Mrs. Jyoti Kammar is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. She actively contributes to teaching, student development, and institutional initiatives. She serves as Coordinator of the Red Cross and Red Ribbon Club, Department Website Coordinator, and IIIC Ambassador. Her area of interest is Power Systems.",
      "bio": "Mrs. Jyoti Kammar is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. She actively contributes to teaching, student development, and institutional initiatives. She serves as Coordinator of the Red Cross and Red Ribbon Club, Department Website Coordinator, and IIIC Ambassador. Her area of interest is Power Systems.",
      "specializations": [
        "Power System"
      ],
      "areas": [
        "Power System"
      ],
      "courses": [
        "Electric Circuit Analysis",
        "Wireless Communication System",
        "Control System",
        "Electromagnetic Theory"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/jyoti-kammar-a54630393",
      "irins": "https://vapt6.irins.org/profile-detail/1000062",
      "recognition": [
        "Published Patent, Completed National Programme on Technology Enhanced Learning (NPTEL) Courses",
        "Red cross and red ribbon Club coordinator",
        "Institution Innovation Council (IIC) innovation Ambassador",
        "Website Coordinator"
      ]
    },
    {
      "id": "f-nikhil-a-kulkarni",
      "name": "Mr. Nikhil A. Kulkarni",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/nikhil_kulkarni_ECE.jpeg",
      "email": "nak@klsvdit.edu.in",
      "phone": "+91 96113 61637",
      "showPhone": false,
      "experience": "14 years",
      "description": "Mr. Nikhil A. Kulkarni holds an M.Tech in VLSI Design and Embedded Systems and a B.E. in Electronics and Communication Engineering. His areas of interest include Embedded Systems, VLSI Design, Digital Electronics, and FPGA-Based System Design. He is actively involved in teaching, research, and technology-driven learning in the field of Electronics and Communication Engineering.",
      "bio": "Mr. Nikhil A. Kulkarni holds an M.Tech in VLSI Design and Embedded Systems and a B.E. in Electronics and Communication Engineering. His areas of interest include Embedded Systems, VLSI Design, Digital Electronics, and FPGA-Based System Design. He is actively involved in teaching, research, and technology-driven learning in the field of Electronics and Communication Engineering.",
      "specializations": [
        "Embedded Systems",
        "Very Large Scale Integration (VLSI) Design",
        "Digital Electronics",
        "Field Programmable Gate Array (FPGA) and Application Specific Integrated Circuit (ASIC) Design"
      ],
      "areas": [
        "Embedded Systems",
        "Very Large Scale Integration (VLSI) Design",
        "Digital Electronics",
        "Field Programmable Gate Array (FPGA) and Application Specific Integrated Circuit (ASIC) Design"
      ],
      "courses": [
        "Embedded System Design",
        "Network Analysis",
        "Electromagnetics",
        "VHSIC Hardware Description Language (VHDL) And Verilog"
      ],
      "publications": 10,
      "projects": 3,
      "linkedin": "https://www.linkedin.com/in/nikhil-kulkarni-7b4204112/",
      "irins": "https://klsvdit.irins.org/profile/249320",
      "recognition": [
        "National Programme on Technology Enhanced Learning (NPTEL)",
        "Indian Institute of Technology (IIT) Bombay Spoken Tutorial and National Programme on Technology Enhanced Learning (NPTEL) Coordinator"
      ]
    },
    {
      "id": "f-pooja-c-shindhe",
      "name": "Ms. Pooja C Shindhe",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/pooja_shinde_ECE.jpeg",
      "email": "pcs@klsvdit.edu.in",
      "phone": "+91 93539 88748",
      "showPhone": false,
      "experience": "4 years",
      "description": "Ms.Pooja Shindhe serves as an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. Her research interests include image compression and related signal processing techniques. She is actively involved in promoting innovation and entrepreneurship as an Innovation Ambassador under Institution's Innovation Council (IIC), contributing to academic excellence and student development.",
      "bio": "Ms.Pooja Shindhe serves as an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. Her research interests include image compression and related signal processing techniques. She is actively involved in promoting innovation and entrepreneurship as an Innovation Ambassador under Institution's Innovation Council (IIC), contributing to academic excellence and student development.",
      "specializations": [
        "Image Processing/ compression",
        "Multimedia Communication"
      ],
      "areas": [
        "Image Processing/ compression",
        "Multimedia Communication"
      ],
      "courses": [
        "Network Analysis",
        "Microwave And Antenna Theory",
        "Electromagnetic Theory",
        "Multimedia Communication"
      ],
      "publications": 6,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/pooja-shindhe-261343159?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      "irins": "https://klsvdit.irins.org/profile/441255",
      "recognition": [
        "Innovation Ambassador under the Institution's Innovation Council (Institution Innovation Council (IIC))",
        "Doctor of Philosophy (Ph.D.) Research Scholar",
        "Internship Coordinator",
        "Department Student Association coordinator ( \\u0cb8\\u0c82\\u0cb5\\u0cb9\\u0ca8) Activities"
      ]
    },
    {
      "id": "f-suraj-kadli",
      "name": "Mr. Suraj Kadli",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/suraj_kadli_ECE.jpeg",
      "email": "sbk@klsvdit.edu.in",
      "phone": "+91 96325 61162",
      "showPhone": false,
      "experience": "12 years",
      "description": "Mr. Suraj Kadli is Assistant Professor in the Department of Electronics and Communication Engineering. His research focuses on Optimization of Audio Compression algorithms using Deep Learning techniques. He has guided 5 PG projects.",
      "bio": "Mr. Suraj Kadli is Assistant Professor in the Department of Electronics and Communication Engineering. His research focuses on Optimization of Audio Compression algorithms using Deep Learning techniques. He has guided 5 PG projects.",
      "specializations": [
        "Signal Processing",
        "Audio Compression"
      ],
      "areas": [
        "Signal Processing",
        "Audio Compression"
      ],
      "courses": [
        "Digital Signal Processing",
        "Control Systems",
        "Automotive Electronics",
        "Introduction To Artificial Intelligence (AI) And Applications"
      ],
      "publications": 7,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/suraj-kadli-klsvdit-haliyal",
      "irins": "https://klsvdit.irins.org/profile/249301",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-a-v-kolaki",
      "name": "Mr. A V Kolaki",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/allamprabhu_kolaki_ECE.jpeg",
      "email": "avk@klsvdit.edu.in",
      "phone": "+91 93430 88337",
      "showPhone": false,
      "experience": "26 years",
      "description": "Mr. A. V. Kolaki has been serving as an Assistant Professor in the Department of Electronics and Communication Engineering (E&CE) since 2004. With over two decades of teaching experience, he has been actively involved in imparting quality education, mentoring students, and contributing to various academic and administrative activities of the institution. He is also serving as the VDIT Examination Coordinator, responsible for the effective planning, coordination, and conduct of examination-related activities.",
      "bio": "Mr. A. V. Kolaki has been serving as an Assistant Professor in the Department of Electronics and Communication Engineering (E&CE) since 2004. With over two decades of teaching experience, he has been actively involved in imparting quality education, mentoring students, and contributing to various academic and administrative activities of the institution. He is also serving as the VDIT Examination Coordinator, responsible for the effective planning, coordination, and conduct of examination-related activities.",
      "specializations": [
        "Digital Communication",
        "Secured Communication"
      ],
      "areas": [
        "Digital Communication",
        "Secured Communication"
      ],
      "courses": [
        "Digital Circuits",
        "Cryptography",
        "Fundamentals Of. Electronics",
        "Computer Netwoking"
      ],
      "publications": 15,
      "projects": 2,
      "linkedin": "www.linkedin.com/in/allamprabhu-kolaki-bb0b54",
      "irins": "https://klsvdit.irins.org/profile/259319#pb_information_panel",
      "recognition": [
        "Worked as Computer Center Head"
      ]
    },
    {
      "id": "f-plasin-francis-dias",
      "name": "Dr. Plasin Francis Dias",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech., Ph.D.",
      "qualifications": "M.Tech., Ph.D.",
      "image": "/FacultyCImages/DR_plasin_dias_ECE.jpeg",
      "email": "pfd@klsvdit.edu.in",
      "phone": "+91 94484 05268",
      "showPhone": false,
      "experience": "26 years",
      "description": "Dr. Plasin Francis Dias is a faculty in Electronics and Communication Engineering. Her research focuses on Synthetic Aperture Radar (SAR) Polarimetry, image processing, signal processing, and VLSI-based implementations for remote sensing applications. Her interests include radar signal analysis, FPGA design, and advanced techniques for Earth observation and environmental monitoring. She has published 18 research papers in reputed journals and conferences and is actively engaged in advanced research and academic activities.",
      "bio": "Dr. Plasin Francis Dias is a faculty in Electronics and Communication Engineering. Her research focuses on Synthetic Aperture Radar (SAR) Polarimetry, image processing, signal processing, and VLSI-based implementations for remote sensing applications. Her interests include radar signal analysis, FPGA design, and advanced techniques for Earth observation and environmental monitoring. She has published 18 research papers in reputed journals and conferences and is actively engaged in advanced research and academic activities.",
      "specializations": [
        "Signal Processing",
        "Very Large Scale Integration (VLSI)",
        "Image Processing",
        "Communication System"
      ],
      "areas": [
        "Signal Processing",
        "Very Large Scale Integration (VLSI)",
        "Image Processing",
        "Communication System"
      ],
      "courses": [
        "Digital Image Processing",
        "Analog Mixed Mode Very Large Scale Integration (VLSI) Design",
        "Principles Of Communication Systems",
        "Signals And Systems"
      ],
      "publications": 18,
      "projects": 2,
      "linkedin": "https://linkedin.com/in/plasin-dias-966b6716b",
      "irins": "https://klsvdit.irins.org/profile/249316",
      "recognition": [
        "A research article title \"Entropy Based target Identification in Synthetic Aperture Radar Polarimetry\", received Best Paper Award in \"The 2nd World Summit on Advances in Science, Engineering and Technology, Indiana Summit 2019\", Indiana University Perdue University Indianapolis, USA, International Journal of Engineering and Advanced Technology (IJEAT),",
        "A research article title \"Quantitative Approach for Snowy Feature Detection using Polarimetric Analysis\", received Best Paper Award in the Science Direct, Global Transitions Proceedings, International Conference on Intelligent Engineering Approach (ICIEA-2022)",
        "Member of Institution of Engineers India (IEI)",
        "Life member of A member of Indian Society for Technical Education (ISTE)",
        "Life Member of International Association of Engineers (IAENG)"
      ]
    },
    {
      "id": "f-vijayalaxmi-c-kalal",
      "name": "Mrs. Vijayalaxmi C. Kalal",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/vijayalaxmi_kalal_ECE.jpeg",
      "email": "vck@klsvdit.edu.in",
      "phone": "+91 88616 23824",
      "showPhone": false,
      "experience": "9 years",
      "description": "Mrs. Vijayalaxmi C. Kalal is a passionate academician and researcher in the field of VLSI and Embedded Systems. She earned her M.Tech in VLSI Design and Embedded Systems from VTU, Belagavi, and is currently pursuing her Ph.D. in VLSI. With 10 research publications in reputed journals and conferences, she is dedicated to advancing semiconductor technology through innovative research, inspiring teaching, and a commitment to technological excellence.",
      "bio": "Mrs. Vijayalaxmi C. Kalal is a passionate academician and researcher in the field of VLSI and Embedded Systems. She earned her M.Tech in VLSI Design and Embedded Systems from VTU, Belagavi, and is currently pursuing her Ph.D. in VLSI. With 10 research publications in reputed journals and conferences, she is dedicated to advancing semiconductor technology through innovative research, inspiring teaching, and a commitment to technological excellence.",
      "specializations": [
        "Very Large Scale Integration (VLSI)",
        "Embedded Systems",
        "Artificial Intelligence",
        "Communication System"
      ],
      "areas": [
        "Very Large Scale Integration (VLSI)",
        "Embedded Systems",
        "Artificial Intelligence",
        "Communication System"
      ],
      "courses": [
        "Very Large Scale Integration (VLSI) Design",
        "Satellite Communication",
        "Internet Of Things",
        "Advanced Control Systems"
      ],
      "publications": 12,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/vijaylaxmi-kalal-150a3685?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      "irins": "https://klsvdit.irins.org/profile/378246",
      "recognition": [
        "Karnataka State Council for Science and Technology (KSCST) Student Project Programme (SPP) Coordinator of Institute",
        "Received Gold Medal in M.Tech (Master of Technology) in Very Large Scale Integration (VLSI) Design and Embedded Systems from Visvesvaraya Technological University (VTU), Belagavi for securing 1st Rank in the college"
      ]
    },
    {
      "id": "f-rohini-kallur",
      "name": "Mrs. Rohini Kallur",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/rohini_kallur_ECE.jpeg",
      "email": "rrk@klsvdit.edu.in",
      "phone": "+91 98865 75189",
      "showPhone": false,
      "experience": "18 years",
      "description": "Mrs. Rohini Kallur is an Assistant Professor with expertise in Communication Systems, Embedded Systems. She is currently purusing Ph.D in Communication domain from VTU, Belagavi. She has authored 20 research papers in reputed national and international journals and conferences. She also serves as a reviewer for reputed Scopus-indexed journals and has guided a KSCST-funded project. Passionate about teaching and research, she is dedicated to advancing knowledge and fostering innovation in the field of Electronics and Communication Engineering.",
      "bio": "Mrs. Rohini Kallur is an Assistant Professor with expertise in Communication Systems, Embedded Systems. She is currently purusing Ph.D in Communication domain from VTU, Belagavi. She has authored 20 research papers in reputed national and international journals and conferences. She also serves as a reviewer for reputed Scopus-indexed journals and has guided a KSCST-funded project. Passionate about teaching and research, she is dedicated to advancing knowledge and fostering innovation in the field of Electronics and Communication Engineering.",
      "specializations": [
        "Communication Engineering",
        "Optical Networks",
        "Embedded Systems"
      ],
      "areas": [
        "Communication Engineering",
        "Optical Networks",
        "Embedded Systems"
      ],
      "courses": [
        "Power Electronics",
        "Principles Of Communication Systems",
        "Artificial Intelligence And Machine Learning",
        "Digitial System Design Using Verilog"
      ],
      "publications": 20,
      "projects": 1,
      "linkedin": "https://www.linkedin.com/in/rohini-kallur-4a304713a?trk=contact-info",
      "irins": "https://klsvdit.irins.org/profile/249295",
      "recognition": [
        "Received Best paper award for the paper \"Optimization of Energy in Wavelength Division Multiplexing (WDM) Passive Optical Network\", in Research and Innovation in Science, Engineering and Management (RISEM)",
        "Seceratary of Kalpavruksha Kannada Sangha, Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT), Haliyal",
        "Member of Institution of Engineers India (IEI)",
        "Life Member of International Association of Engineers (IAENG)"
      ]
    },
    {
      "id": "f-mahendra-m-dixit",
      "name": "Dr. Mahendra M. Dixit",
      "designation": "Professor & Dean",
      "role": "Professor & Dean",
      "qualification": "M.Tech., Ph.D.",
      "qualifications": "M.Tech., Ph.D.",
      "image": "/FacultyCImages/DR_mahendra_dixit_ECE.jpeg",
      "email": "mmd@klsvdit.edu.in",
      "phone": "+91 97318 69101",
      "showPhone": false,
      "experience": "19 years",
      "description": "Dr. Mahendra M. Dixit is an Associate Professor in the Department of Electronics and Communication Engineering. He has been serving at SDM College of Engineering and Technology, Dharwad, since 2008. His academic and research interests include VLSI Design, Embedded Systems, and Image Processing, contributing to teaching, research, and student development.",
      "bio": "Dr. Mahendra M. Dixit is an Associate Professor in the Department of Electronics and Communication Engineering. He has been serving at SDM College of Engineering and Technology, Dharwad, since 2008. His academic and research interests include VLSI Design, Embedded Systems, and Image Processing, contributing to teaching, research, and student development.",
      "specializations": [
        "Very Large Scale Integration (VLSI) Design",
        "Embedded Systems",
        "Digital Image Processing",
        "Agricultural Technology"
      ],
      "areas": [
        "Very Large Scale Integration (VLSI) Design",
        "Embedded Systems",
        "Digital Image Processing",
        "Agricultural Technology"
      ],
      "courses": [
        "Digital Image Processing",
        "Embedded Systems Design",
        "Essentials Of Information Technology"
      ],
      "publications": 30,
      "projects": 5,
      "linkedin": "",
      "irins": "",
      "recognition": [
        "Recognized Reviewer for Springer, Elsevier Science, Taylor and Francis, Institute of Electrical and Electronics Engineers (IEEE) Transactions, Institution of Engineering and Technology (IET) (UK)",
        "Worked as Head of the Department (Electronics and Communication Engineering (E&CE)) for the period of 5+ Years at Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) Haliyal",
        "Worked as Dean Research and Development for the period of 2 Years at Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) Haliyal",
        "Working as President of Institution's Innovation Council (Institution Innovation Council (IIC)) since it's inception at Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) Haliyal"
      ]
    },
    {
      "id": "f-deepak-sharma",
      "name": "Mr. Deepak Sharma",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/deepak_sharma_ECE.jpeg",
      "email": "dss@klsvdit.edu.in",
      "phone": "+91 94818 60756",
      "showPhone": false,
      "experience": "11 years",
      "description": "Mr. Deepak Sharma is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. He holds B.E. and M.Tech degrees from SDMCET, Dharwad. His research interests include Low-Power VLSI and Digital Circuit Design. He is currently pursuing a Ph.D. under VTU, Belagavi, at KLS VDIT.",
      "bio": "Mr. Deepak Sharma is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. He holds B.E. and M.Tech degrees from SDMCET, Dharwad. His research interests include Low-Power VLSI and Digital Circuit Design. He is currently pursuing a Ph.D. under VTU, Belagavi, at KLS VDIT.",
      "specializations": [
        "Digital Very Large Scale Integration (VLSI) Circuits"
      ],
      "areas": [
        "Digital Very Large Scale Integration (VLSI) Circuits"
      ],
      "courses": [
        "Analog Electronics",
        "Very Large Scale Integration (VLSI) Design And Testing",
        "Basic Electronics",
        "Automotive Electronics"
      ],
      "publications": 10,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/prof-deepak-sharma-a8362950",
      "irins": "https://klsvdit.irins.org/profile/178730",
      "recognition": [
        "Reviewer for international journals",
        "Innovation Ambassador"
      ]
    }
  ]
};

export default facultyData;
